import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EmpleadosService } from '../../services/empleados.service';

import { EmpleadosTooltipComponent } from '../empleados-tooltip/empleados-tooltip.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { DatosEmpleadosService } from '../../services/mantenimiento/datos-empleados.service';

@Component({
  selector: 'app-upload-excel-empleados',
  templateUrl: './upload-excel-empleados.component.html',
  styleUrls: ['./upload-excel-empleados.component.css']
})
export class UploadExcelEmpleadosComponent implements OnInit, OnDestroy {

  private static readonly CHUNK_SIZE = 500;

  mensajeCarga: string = 'Subiendo datos al servidor espere';
  mensajeCargaIni: string = 'Subiendo datos al servidor espere';
  mostrarTablaEmpleados = false;
  cargandoEmpleados = false;
  /** Bloquea la UI mientras se lee/valida el Excel en cliente. */
  leyendoExcel = false;
  empleados: any[] = [];
  empleadosFiltro: any[] = [];
  empleadosErroneos = false;
  /** Progreso de subida por lotes (de la operación actual). */
  empleadosSubidos = 0;
  empleadosTotal = 0;

  get progresoSubidaPorcentaje(): number {
    if (this.empleadosTotal <= 0) {
      return 0;
    }
    return (this.empleadosSubidos / this.empleadosTotal) * 100;
  }

  api: any;
  apiCol: any;
  resumenEmpleados = '';
  verNuevasParam = false;
  getRowStyle: any = function (params: any) {
    if (params.data.error) return { background: '#FEE4E2' };
    else return {};
  };
  frameworkComponents: any = { empleadosTooltip: EmpleadosTooltipComponent };

  private intervalLogSubida: any;
  private lotesPendientes: any[][] = [];
  private tamanoLoteEnCurso = 0;
  private idLogEnCurso: string | null = null;
  private esperandoRespuestaLog = false;
  private subidaCerrada = false;
  /** Total fijado al iniciar ESTA subida; no se reutiliza el de operaciones anteriores. */
  private totalOperacion = 0;
  private generacionSubida = 0;
  /** Evita que getSubidaPendiente interfiera tras cargar un Excel local. */
  private ignorarReenganchePendiente = false;
  private subidaPendienteSub?: Subscription;

  hayErrores: boolean;

  overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Cargando...</span>';
  overlayNoRowsTemplate = '<span>No se han encontrado empleados</span>';

  constructor(
    public empleadoService: EmpleadosService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private datosEmpleadosService: DatosEmpleadosService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getExcelConfiguration();
    this.mensajeCarga = 'Subiendo datos al servidor espere';

    this.subidaPendienteSub = this.empleadoService.getSubidaPendiente().subscribe(id => {
      if (this.ignorarReenganchePendiente) {
        return;
      }
      this.verCargasAntriores(id);
    });
  }

  ngOnDestroy(): void {
    this.subidaPendienteSub?.unsubscribe();
    this.detenerPollingLog();
  }

  verCargasAntriores(id: string) {
    if (!id || id.trim() === '') {
      return;
    }
    if (this.ignorarReenganchePendiente || this.empleados?.length > 0 || this.mostrarTablaEmpleados) {
      return;
    }

    this.generacionSubida += 1;
    const generacion = this.generacionSubida;
    this.subidaCerrada = false;
    this.idLogEnCurso = id;
    this.esperandoRespuestaLog = false;
    this.tamanoLoteEnCurso = 0;
    this.empleadosSubidos = 0;
    this.empleadosTotal = 0;
    this.totalOperacion = 0;
    this.lotesPendientes = [];
    this.cargandoEmpleados = true;
    this.mostrarTablaEmpleados = false;
    this.mensajeCarga = 'Procesando empleados....';
    this.detenerPollingLog();
    this.intervalLogSubida = setInterval(() => this.verLogSubida(id, generacion), 5000);
  }

  cargaApi(arg: any) {
    this.api = arg.api;
    this.apiCol = arg.columnApi;
  }

  getExcelConfiguration(descargar: boolean = false) {
    this.empleadoService.getConfiguration().subscribe(
      next => {},
      error => {
        if (error.status !== 401) this._snackBar.open(error.message, 'Cerrar', { duration: 4000 });
      }
    );
    return;
  }

  async uploadFiles(files: FileList) {
    if (!this.empleadoService.validateConfiguration()) return;
    if (!files?.item(0)) return;

    this.ignorarReenganchePendiente = true;
    this.detenerPollingLog();
    this.generacionSubida += 1;
    this.subidaCerrada = true;
    this.idLogEnCurso = null;
    this.esperandoRespuestaLog = false;
    this.lotesPendientes = [];
    this.empleadosSubidos = 0;
    this.empleadosTotal = 0;
    this.totalOperacion = 0;
    this.tamanoLoteEnCurso = 0;
    this.cargandoEmpleados = false;

    const generacionLectura = this.generacionSubida;
    this.leyendoExcel = true;
    try {
      const leidos = await this.empleadoService.readFile(files.item(0));
      if (generacionLectura !== this.generacionSubida) {
        return;
      }

      this.empleados = leidos;
      const errores = this.empleados.filter(x => x.error).length;
      this.resumenEmpleados = `Se han leído ${this.empleados?.length} registros, ${errores} contienen errores`;
      this.empleadosErroneos = errores > 0;
      this.hayErrores = errores > 0;

      if (this.empleados?.length > 0) {
        this.mostrarTablaEmpleados = true;
        this.seleccionFiltroChange(false);
      } else {
        this._snackBar.open('No se han encontrado coincidencias con las cabeceras configuradas', 'Cerrar', { duration: 3000 });
      }
    } catch {
      this._snackBar.open('No se ha podido leer el fichero Excel. Inténtalo de nuevo.', 'Cerrar', { duration: 4000 });
    } finally {
      if (generacionLectura === this.generacionSubida) {
        this.leyendoExcel = false;
      }
    }
  }

  seleccionFiltroChange(mostrarErrores: boolean) {
    if (mostrarErrores) this.empleadosFiltro = this.empleados.filter(x => x.error);
    else this.empleadosFiltro = this.empleados;
  }

  actualizarEmpleados() {
    if (this.empleadosErroneos) {
      this.dialog.open(ModalMessageComponent, {
        data: {
          mensaje: 'Hay errores, no se puede actualizar los empleados. Descarga, edita los registros erróneos y vuelve a cargar el excel.',
          alert: true
        },
      });
      return;
    }

    const empleadosParaSubir = this.empleados.slice();

    if (!empleadosParaSubir.length) {
      this._snackBar.open('No hay empleados para subir. Vuelve a cargar el Excel.', 'Cerrar', { duration: 4000 });
      return;
    }

    this.ignorarReenganchePendiente = true;
    this.cargandoEmpleados = true;
    this.mostrarTablaEmpleados = false;
    this.iniciarSubidaEmpleados(empleadosParaSubir);
  }

  private partirEnChunks(empleados: any[], chunkSize = UploadExcelEmpleadosComponent.CHUNK_SIZE): any[][] {
    const chunks: any[][] = [];
    for (let i = 0; i < empleados.length; i += chunkSize) {
      chunks.push(empleados.slice(i, i + chunkSize));
    }
    return chunks;
  }

  private iniciarSubidaEmpleados(empleadosParaSubir: any[]): void {
    this.detenerPollingLog();
    this.generacionSubida += 1;
    const generacion = this.generacionSubida;
    this.subidaCerrada = false;
    this.idLogEnCurso = null;
    this.esperandoRespuestaLog = false;

    this.lotesPendientes = this.partirEnChunks(empleadosParaSubir);
    this.totalOperacion = empleadosParaSubir.length;
    this.empleadosTotal = this.totalOperacion;
    this.empleadosSubidos = 0;
    this.tamanoLoteEnCurso = 0;
    this.mensajeCarga = 'Procesando empleados....';

    this.enviarSiguienteLote(generacion);
  }

  private enviarSiguienteLote(generacion: number): void {
    if (this.subidaCerrada || generacion !== this.generacionSubida) {
      return;
    }

    if (this.lotesPendientes.length === 0) {
      this.finalizarSubidaExitosa(generacion);
      return;
    }

    const lote = this.lotesPendientes.shift();
    this.tamanoLoteEnCurso = lote.length;

    this.empleadoService.addEmpleados(lote).subscribe(
      next => {
        if (this.subidaCerrada || generacion !== this.generacionSubida) {
          return;
        }
        this.mensajeCarga = 'Procesando empleados....';
        this.detenerPollingLog();
        this.idLogEnCurso = next;
        this.esperandoRespuestaLog = false;
        this.intervalLogSubida = setInterval(() => this.verLogSubida(next, generacion), 5000);
      },
      error => {
        if (generacion !== this.generacionSubida) {
          return;
        }
        this.pararCadenaSubida();
        const mensaje = typeof error === 'string'
          ? error
          : (error?.message || 'No se han podido actualizar los empleados.');
        if (error?.status !== 401) {
          this._snackBar.open(mensaje, 'Cerrar', { duration: 4000 });
        }
      }
    );
  }

  private detenerPollingLog(): void {
    if (this.intervalLogSubida) {
      clearInterval(this.intervalLogSubida);
      this.intervalLogSubida = null;
    }
  }

  private pararCadenaSubida(): void {
    this.subidaCerrada = true;
    this.idLogEnCurso = null;
    this.esperandoRespuestaLog = false;
    this.detenerPollingLog();
    this.lotesPendientes = [];
    this.tamanoLoteEnCurso = 0;
    this.mensajeCarga = this.mensajeCargaIni;
    this.cargandoEmpleados = false;
    this.mostrarTablaEmpleados = false;
  }

  private finalizarSubidaExitosa(generacion: number): void {
    if (this.subidaCerrada || generacion !== this.generacionSubida) {
      return;
    }
    this.subidaCerrada = true;
    this.idLogEnCurso = null;
    this.esperandoRespuestaLog = false;
    this.datosEmpleadosService.refreshEmpleados = true;
    this.mensajeCarga = this.mensajeCargaIni;
    this.detenerPollingLog();

    // Siempre el total de ESTA operación (no un contador residual de la anterior)
    const total = this.totalOperacion;
    const mensaje = total > 0
      ? `Proceso de carga de empleados finalizado correctamente. Se han cargado ${total} empleados.`
      : 'Proceso de carga de empleados finalizado correctamente.';

    this.cargandoEmpleados = false;
    this.mostrarTablaEmpleados = false;

    this.dialog.closeAll();
    this.dialog.open(ModalMessageComponent, {
      data: { mensaje }
    }).afterClosed().subscribe(() => {
      this.router.navigateByUrl('/panel/configuracion/empleados');
    });
  }

  private finalizarReenganchePendiente(generacion: number): void {
    if (this.subidaCerrada || generacion !== this.generacionSubida) {
      return;
    }
    this.subidaCerrada = true;
    this.idLogEnCurso = null;
    this.esperandoRespuestaLog = false;
    this.detenerPollingLog();
    this.datosEmpleadosService.refreshEmpleados = true;
    this.cargandoEmpleados = false;
    this.mensajeCarga = this.mensajeCargaIni;

    this.dialog.closeAll();
    this.dialog.open(ModalMessageComponent, {
      data: { mensaje: 'Proceso de carga de empleados finalizado correctamente.' }
    }).afterClosed().subscribe(() => {
      this.router.navigateByUrl('/panel/configuracion/empleados');
    });
  }

  verLogSubida(id: string, generacion: number) {
    if (this.subidaCerrada || this.esperandoRespuestaLog || this.idLogEnCurso !== id || generacion !== this.generacionSubida) {
      return;
    }

    this.esperandoRespuestaLog = true;

    this.empleadoService.GetLog(id).subscribe(
      next => {
        this.esperandoRespuestaLog = false;
        if (this.subidaCerrada || this.idLogEnCurso !== id || generacion !== this.generacionSubida) {
          return;
        }

        switch (next.estado) {
          case 'PROCESANDO':
            this.mensajeCarga = 'Procesando empleados....';
            break;
          case 'FINALIZADO':
            this.detenerPollingLog();
            this.idLogEnCurso = null;

            // Reenganche sin lotes locales: no usar totales de otra operación
            if (this.totalOperacion <= 0 && this.lotesPendientes.length === 0) {
              this.finalizarReenganchePendiente(generacion);
              break;
            }

            this.empleadosSubidos += this.tamanoLoteEnCurso;
            this.tamanoLoteEnCurso = 0;

            if (this.lotesPendientes.length > 0) {
              this.enviarSiguienteLote(generacion);
            } else {
              this.finalizarSubidaExitosa(generacion);
            }
            break;
          default:
            this.pararCadenaSubida();
            this._snackBar.open(`Se ha producido un eror en el proceso: ${next.errorMessage}`, 'Cerrar', { duration: 3000 });
            break;
        }
      },
      error => {
        this.esperandoRespuestaLog = false;
        if (this.subidaCerrada || this.idLogEnCurso !== id || generacion !== this.generacionSubida) {
          return;
        }
        this.pararCadenaSubida();
        this._snackBar.open(error.message, 'Se ha producido un error en la carga', { duration: 3000 });
      }
    );
  }

  exportarPlantillaEmpleados() {
    if (!this.empleadoService.validateConfiguration()) return;

    let cabecerasExport: any = {};
    Object.keys(this.empleadoService.empleadosEstructura).forEach(x => {
      if (x != 'errorMensaje') cabecerasExport[x] = '';
    });

    this.empleadoService.exportaExcel([this.empleadoService.empledosDefaultEstructura], true);
  }

  exportarEmpleados() {
    this.empleadoService.exportaExcel(this.empleadosFiltro, false);
  }

  atras() {
    this.empleados = [];
    this.empleadosFiltro = [];
    this.cargandoEmpleados = false;
    this.mostrarTablaEmpleados = false;
    this.empleadosErroneos = false;
    this.hayErrores = false;
    this.resumenEmpleados = '';
    this.detenerPollingLog();
    this.generacionSubida += 1;
    this.subidaCerrada = true;
    this.idLogEnCurso = null;
    this.esperandoRespuestaLog = false;
    this.lotesPendientes = [];
    this.empleadosSubidos = 0;
    this.empleadosTotal = 0;
    this.totalOperacion = 0;
    this.tamanoLoteEnCurso = 0;
    this.mensajeCarga = this.mensajeCargaIni;
  }

}
